import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Action } from '../../actions';

const DEFAULT_TOAST_DISPLAY_TIME = 5000;

export enum BarType {
	Error = 'error',
	Info = 'info'
}

export interface NotificationArguments {
	id: number;
}

export enum NotificationBarActionKeys {
	CREATE_NOTIFICATION = '@@notificationBar/CREATE_NOTIFICATION',
	CLEAR_NOTIFICATIONS = '@@notificationBar/CLEAR_NOTIFICATIONS'
}

interface CreateNotificationAction extends Action {
	type: NotificationBarActionKeys.CREATE_NOTIFICATION;
	message: string;
	barType: BarType;
	args?: NotificationArguments;
}

interface ClearNotificationsAction extends Action {
	type: NotificationBarActionKeys.CLEAR_NOTIFICATIONS;
}

export type NotificationBarAction = CreateNotificationAction | ClearNotificationsAction;

let notificationTimer;
export const createNotification = (message: string, args?: NotificationArguments, timer?: number) =>
	 (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	dispatch({
		type: NotificationBarActionKeys.CREATE_NOTIFICATION,
		barType: message.split('.')[0],
		message: message.split('.')[1],
		args,
	});

	dispatch(checkNotificationTimer(timer));
};

const checkNotificationTimer = (timer: number = DEFAULT_TOAST_DISPLAY_TIME) => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	if (notificationTimer) {
		clearTimeout(notificationTimer);
	}
	notificationTimer = timer > 0 ? setTimeout(() => { dispatch(clearNotifications()); }, timer) : undefined;
};

const clearNotifications = (): ClearNotificationsAction => ({ type: NotificationBarActionKeys.CLEAR_NOTIFICATIONS });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotificationBar/actions.ts